export default __webpack_public_path__ + "static/NeffSans-Bold-ec6a64c2a66e7c66a9f9e200a5cd4420.woff";